export default __webpack_public_path__ + "static/media/logo.19e6d5e6.svg";